import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { NodWereHouseRoute } from "./nod-were-house.routes";

export function NodWereHouse() {
  return (
    <Layout>
      {NodWereHouseRoute.subRoutes && (
        <ModuleRouter subRoutes={NodWereHouseRoute.subRoutes} path={NodWereHouseRoute.path} />
      )}
    </Layout>
  );
}
